import { Components, Theme } from "@mui/material";

export const MuiDialog: Components<Theme>["MuiDialog"] = {
  styleOverrides: {
    scrollPaper: {
      backgroundColor: "rgb(0, 97, 72, 0.70)",
    },
    paper: ({ theme }) => ({
      [theme.breakpoints.down("xs")]: {
        margin: 15,
        "& >div:nth-child(2)": {
          padding: 15,
        },
      },
    }),
  },
};
